import React, { useState, useEffect } from "react";
import { gsap } from "gsap";
import "./TalkingCharacter.css";
import characterImg from "../assets/talking/character.png";
import mouthImg from "../assets/talking/mouth.png";
import eyesImg from "../assets/talking/eyes.png";

const TalkingCharacter = ({ text }) => {
  const [isTalking, setIsTalking] = useState(false);
  const [synth, setSynth] = useState(null);
  const [utterance, setUtterance] = useState(null);

  useEffect(() => {
    const synthInstance = window.speechSynthesis;
    setSynth(synthInstance);

    const utteranceInstance = new SpeechSynthesisUtterance(text);
    utteranceInstance.onstart = () => {
      setIsTalking(true);
      startMouthAnimation();
    };
    utteranceInstance.onend = () => {
      setIsTalking(false);
      stopMouthAnimation();
    };
    setUtterance(utteranceInstance);

    // Stop speech when user leaves or reloads the page
    const handleBeforeUnload = () => {
      synthInstance.cancel();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      synthInstance.cancel();
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [text]);

  const startMouthAnimation = () => {
    gsap.to(".mouth", {
      y: -5,
      scaleY: 1.2,
      repeat: -1,
      yoyo: true,
      duration: 0.1,
    });
  };

  const stopMouthAnimation = () => {
    gsap.to(".mouth", { scaleY: 1, y: 0, duration: 0.1 });
  };

  useEffect(() => {
    const blinkInterval = setInterval(() => {
      gsap.to(".eyes", { opacity: 0, duration: 0.1 });
      setTimeout(() => gsap.to(".eyes", { opacity: 1, duration: 0.1 }), 200);
    }, 3000);

    return () => clearInterval(blinkInterval);
  }, []);

  const toggleSpeech = () => {
    if (!synth || !utterance) return;

    if (isTalking) {
      synth.cancel(); // Stop speaking
      setIsTalking(false);
      stopMouthAnimation();
    } else {
      synth.speak(utterance); // Start speaking
    }
  };

  return (
    <div className="character-container" onClick={toggleSpeech} style={{ cursor: "pointer" }}>
      <img src={characterImg} alt="Character" className="character" />
      <img src={mouthImg} alt="Mouth" className={`mouth ${isTalking ? "talking" : ""}`} />
      <img src={eyesImg} alt="Eyes" className="eyes" />
    </div>
  );
};

export default TalkingCharacter;
